<app-header4></app-header4>
<div class="page-title-area page-title-area3">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="banner-content mLText">
                    <span data-animation="fadeInLeft" data-delay="0.5s" class="bienVenu">BIENVENUE À L'ISN POLYSCIENCE</span>
                    <h1 data-animation="fadeInLeft" data-delay="0.9s" class="title c-title">{{textafficher}}</h1>
                </div>
            </div>
        </div>
    </div>
</div>


<!-- Sage femme -->
<div class="blog-standard-area" *ngIf="datas=='SAGES-FEMMES'">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-12">
                <div class="blog-standard">
                    <div class="single-blog-standard  mt-30">
                        <div class="blog-dteails-content blog-border">
                            <div class="blog-details-top">
                                <span>Les objectifs</span>
                            </div>
                            <br>
                            <div class="blog-details-bath">
                                <p class="c-description">L'approche par compétences sert de cadre de référence pour former des infirmiers (ou infirmières) et des sage-femmes (ou maïeuticiens) aptes à assurer les démarches en promotion et en prévention, à réaliser des soins conformes
                                    aux attentes de la population et des professionnels de la santé.</p>
                            </div>

                            <br>

                            <div class="blog-details-top">
                                <span><div class="blog-details-top">
                                    <span>Compétences communes</span>
                            </div>
                            </span>
                        </div>
                        <br>
                        <div class="blog-details-bath">
                            <ul class="list-group c-paddingLeft">
                                <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>C1. Analyser la fonction liée aux professions infirmières et sage-femmes ;</a></li>
                                <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>C2. Prendre en charge une situation clinique en se référant à la physiologie et aux pathologies du corps humain ;</a></li>
                                <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>C3. Intervenir en santé communautaire ;</a></li>
                                <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>C4. Appliquer les méthodes et techniques des soins infirmiers et obstétricaux ;</a></li>
                                <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>C5. Appliquer le processus de la recherche ;</a></li>
                                <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>C6. Assurer le management des soins infirmiers et obstétricaux ;</a></li>
                                <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>C7. Assurer les soins promotionnels, préventifs et ré-adaptatifs du couple
                                    « Mère-enfant ».
                                    </a></li>
                            </ul>
                        </div>
                        <div class="blog-details-top">
                            <span><div class="blog-details-top">
                                <span>Compétences spécifiques</span>
                        </div>
                        </span>
                    </div>
                    <br>
                    <div class="blog-details-bath">
                        <h6 class="c-option">Option : sage-femme</h6>
                        <ul class="list-group c-paddingLeft">
                            <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>C8. Fournir des soins prénataux de haute qualité pour la santé optimale de la femme pendant la grossesse (savoir détecter, traiter tôt les complications ou orienter les femmes vers une personne compétente) ;</a></li>
                            <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>C9. Prodiguer des soins obstétricaux et néonataux d'urgence pour maximiser la santé des mères et de leurs nouveaux nés</a></li>
                            <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>C10. Prodiguer des soins culturellement acceptables et de haute qualité pendant la grossesse, le travail, et l'accouchement, réaliser un accouchement sans risque dans les conditions hygiéniques requises et faire face aux situations d'urgences particulières pour maximiser la santé des femmes et de leurs nouveau-nés.</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</div>
</div>

<div class="blog-standard-area" *ngIf="datas=='SAGES-FEMMES'">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-12">
                <div class="blog-standard">
                    <div class="single-blog-standard  mt-30">
                        <div class="blog-dteails-content blog-border">
                            <div class="blog-details-top">
                                <span>DUREE DES ETUDES </span>
                            </div>
                            <br>
                            <div class="blog-details-bath">
                                <p class="c-description">La durée de la formation est de six (06) semestres à raison de deux (02) semestres par an. Un Semestre dure 14 à 16 semaines d'enseignement théorique, d'enseignement pratique, d'enseignement clinique et d'évaluations.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="blog-standard-area" *ngIf="datas=='SAGES-FEMMES'">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-12">
                <div class="blog-standard">
                    <div class="single-blog-standard  mt-30">
                        <div class="blog-dteails-content blog-border">
                            <div class="blog-details-top">
                                <span>Les conditions d’admission</span>
                            </div>
                            <br>
                            <div class="blog-details-bath">
                                <!-- <p class="c-description">La formation peut être suivie en formation initiale, en formation continue ou en alternance (contrat de professionnalisation). <br> Admission par un jury après examen des dossiers de candidature et entretien de motivation.
                                    <br> Peuvent être admis, les candidats ayant des bases sérieuses en informatique et/ou informatique industrielle, issus de formations telles que :
                                </p> -->
                                <ul class="list-group c-paddingLeft">
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Concours direct : Baccalauréat toutes séries ;</a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Pour les non ressortissants de l'espace CEDEAO : Baccalauréat toutes séries et études de dossiers ;</a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Pour les agents de santé : concours professionnel</a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Être apte sur le plan physique, mental et moral.</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div *ngIf="datas=='SAGES-FEMMES'" class="about-faq-area about-faq-area-page pb-100 c-padding-top">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-12">
                <div class="about-faq-content">
                    <span class="critereTitle">Le contenu de la formation</span>
                    <h2 class="title titleMaster">SAGES-FEMMES D’ETAT</h2>
                    <h2 class="title titleMaster c-premier">PREMIÈRE ANNÉE (TRONC COMMUN) </h2>
                    <h2 class="title titleMaster c-semestre">Premier semestre :</h2>
                </div>
                <div class="faq-accordion-3">
                    <div class="accordion" id="accordionExample">
                        <div class="card c-card">
                            <div class="card-header" id="headingOne">
                                <a class="" href="" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                    <i class="fal fa-magic iconColor"></i>UE 1: Connaissances de base liées aux fonctions infirmières et sage-femmes (SIO111)
                                </a>
                            </div>
                            <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Déontologie et éthique professionnelle
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Système National de Santé
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Législation du travail
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Profession infirmière/sage-femme
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="card c-card">
                            <div class="card-header" id="headingTwo">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                    <i class="fal fa-magic iconColor"></i>UE 2: Connaissance de base du corps et de l’alimentation (SIO112)
                                </a>
                            </div>
                            <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Anatomie-Physiologie générale et Anatomie-Physiologie obstétricale
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Puériculture
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Nutrition
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Diététique
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="card c-card">
                            <div class="card-header" id="headingThree">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                    <i class="fal fa-magic iconColor"></i>UE 3: Notions de bases sur les situations cliniques se référant aux pathologies (SIO113)
                                </a>
                            </div>
                            <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Microbiologie
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Hématologie
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;IST/VIH Sida
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Pathologies chirurgicales/sémiologie
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Pathologies médicales/sémiologie
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="card c-card">
                            <div class="card-header" id="headingFour">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                    <i class="fal fa-magic iconColor"></i>UE 4: Santé communautaire (SIO114)
                                </a>
                            </div>
                            <div id="collapseFour" class="collapse" aria-labelledby="headingFour" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Généralité sur la santé communautaire
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Approches de santé communautaire
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Etude du milieu
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Psycho-sociologie/anthropologie
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="card c-card">
                            <div class="card-header" id="headingFive">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                                    <i class="fal fa-magic iconColor"></i>UE 5: Simulation des méthodes et techniques de base en Soins Infirmiers et obstétricaux (SIO115)
                                </a>
                            </div>
                            <div id="collapseFive" class="collapse" aria-labelledby="headingFive" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Théorie et concepts des SI/obstétricaux
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Relation d’aide
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Techniques de soins de base en médecine et en chirurgie
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Secourisme
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="card c-card">
                            <div class="card-header" id="headingSix">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                                    <i class="fal fa-magic iconColor"></i>UE 6: Outils de recherche (SIO116)
                                </a>
                            </div>
                            <div id="collapseSix" class="collapse" aria-labelledby="headingSix" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Anglais professionnel
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Statistiques
                                    </p>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="btnn">
                            <a class="main-btn btnBorder" routerLink='/'>PRE-INSCRIPTION</a>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div *ngIf="datas=='SAGES-FEMMES'" class="about-faq-area about-faq-area-page pb-100 c-padding-top c-semestre2">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-12">
                <div class="about-faq-content">
                    <!-- <span class="critereTitle">Le contenu de la formation</span> -->
                    <!-- <h2 class="title titleMaster">SCIENCES INFIRMIÈRES</h2> -->
                    <h2 class="title titleMaster c-premier">PREMIÈRE ANNÉE (TRONC COMMUN) </h2>
                    <h2 class="title titleMaster c-semestre">Deuxième semestre :</h2>
                </div>
                <div class="faq-accordion-3">
                    <div class="accordion" id="accordionExample">
                        <div class="card c-card">
                            <div class="card-header" id="headingOne">
                                <a class="" href="" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                    <i class="fal fa-magic iconColor"></i>UE 1: Prise en charge des affections primaires I (SIO121)
                                </a>
                            </div>
                            <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Anatomie-Physiologie générale et obstétricale
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Maladies parasitaires
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Biochimie
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Techniques de laboratoire
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Maladies Infectieuses
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="card c-card">
                            <div class="card-header" id="headingTwo">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                    <i class="fal fa-magic iconColor"></i>UE 2: Prise en charge des affections primaires II (SIO122)
                                </a>
                            </div>
                            <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Parasitologie
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Pédiatrie
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Pathologies respiratoires
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Maladies non transmissibles
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Pharmacologie spéciale
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="card c-card">
                            <div class="card-header" id="headingThree">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                    <i class="fal fa-magic iconColor"></i>UE 3: Santé communautaire (SIO123)
                                </a>
                            </div>
                            <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Hygiène et assainissement
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Soins de Santé Primaires
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Épidémiologie
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;IEC/CCC
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="card c-card">
                            <div class="card-header" id="headingFour">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                    <i class="fal fa-magic iconColor"></i>UE 4: Méthodes et Techniques des Soins Infirmiers et obstétricaux (SIO124)
                                </a>
                            </div>
                            <div id="collapseFour" class="collapse" aria-labelledby="headingFour" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Démarche de soins
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Techniques de soins de base
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Soins Infirmiers obstétricaux/néonataux de base/infantiles
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="card c-card">
                            <div class="card-header" id="headingFive">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                                    <i class="fal fa-magic iconColor"></i>UE 5: Processus de la recherche en santé (SIO125)
                                </a>
                            </div>
                            <div id="collapseFive" class="collapse" aria-labelledby="headingFive" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;TIC (Bureautique et Internet)
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>



<div *ngIf="datas=='SAGES-FEMMES'" class="about-faq-area about-faq-area-page pb-100 c-padding-top c-semestre2">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-12">
                <div class="about-faq-content">
                    <!-- <span class="critereTitle">Le contenu de la formation</span> -->
                    <!-- <h2 class="title titleMaster">SCIENCES INFIRMIÈRES</h2> -->
                    <h2 class="title titleMaster c-premier">DEUXIÈME ANNÉE</h2>
                    <h2 class="title titleMaster c-semestre">Troisième semestre :</h2>
                </div>
                <div class="faq-accordion-3">
                    <div class="accordion" id="accordionExample">
                        <div class="card c-card">
                            <div class="card-header" id="headingOne">
                                <a class="" href="" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                    <i class="fal fa-magic iconColor"></i>UE 1: Situation clinique se référant à la physiologie et aux pathologies du corps humain (SIO231)
                                </a>
                            </div>
                            <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Pathologies obstétricales I
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Pathologies gynécologiques I
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="card c-card">
                            <div class="card-header" id="headingTwo">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                    <i class="fal fa-magic iconColor"></i>UE 2: Santé communautaire (SIO232)
                                </a>
                            </div>
                            <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Stratégies conventionnelles et novatrices de communication (IEC/CCC, CIP, Plaidoyer)
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="card c-card">
                            <div class="card-header" id="headingThree">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                    <i class="fal fa-magic iconColor"></i>UE 3: Méthodes et Techniques des Soins Infirmiers et obstétricaux (SIO233)
                                </a>
                            </div>
                            <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Soins infirmiers obstétricaux/néonataux
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="card c-card">
                            <div class="card-header" id="headingFour">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                    <i class="fal fa-magic iconColor"></i>UE 4: Soins promotionnels, préventifs et ré adaptatifs (SIO234)
                                </a>
                            </div>
                            <div id="collapseFour" class="collapse" aria-labelledby="headingFour" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Suivi post natal
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="card c-card">
                            <div class="card-header" id="headingFive">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                                    <i class="fal fa-magic iconColor"></i>UE 5: Soins obstétricaux et néonataux de base (SIO235)
                                </a>
                            </div>
                            <div id="collapseFive" class="collapse" aria-labelledby="headingFive" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Biologie de la reproduction humaine
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Grossesse
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Consultation prénatale
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="card c-card">
                            <div class="card-header" id="headingSix">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                                    <i class="fal fa-magic iconColor"></i>UE 6: Prise en charge de l’accouchement (SIO236)
                                </a>
                            </div>
                            <div id="collapseSix" class="collapse" aria-labelledby="headingSix" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Notions de base du processus de travail
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Accouchement eutocique
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Soins immédiats
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div *ngIf="datas=='SAGES-FEMMES'" class="about-faq-area about-faq-area-page pb-100 c-padding-top c-semestre2">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-12">
                <div class="about-faq-content">
                    <!-- <span class="critereTitle">Le contenu de la formation</span> -->
                    <!-- <h2 class="title titleMaster">SCIENCES INFIRMIÈRES</h2> -->
                    <h2 class="title titleMaster c-premier">DEUXIÈME ANNÉE</h2>
                    <h2 class="title titleMaster c-semestre">Quatrième semestre :</h2>
                </div>
                <div class="faq-accordion-3">
                    <div class="accordion" id="accordionExample">
                        <div class="card c-card">
                            <div class="card-header" id="headingOne">
                                <a class="" href="" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                    <i class="fal fa-magic iconColor"></i>UE 1: Situation clinique se référant à la physiologie et aux pathologies du corps humain (SIO241)
                                </a>
                            </div>
                            <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Pédiatrie
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Pathologies obstétricales I
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Pathologies gynécologiques I
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="card c-card">
                            <div class="card-header" id="headingTwo">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                    <i class="fal fa-magic iconColor"></i>UE 2: Méthodes et Techniques des Soins Infirmiers et obstétricaux (SIO242)
                                </a>
                            </div>
                            <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Soins infirmiers obstétricaux/néonataux
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="card c-card">
                            <div class="card-header" id="headingThree">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                    <i class="fal fa-magic iconColor"></i>UE 3: Soins promotionnels, préventifs et ré adaptatifs (SIO243)
                                </a>
                            </div>
                            <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Consultation des enfants sains
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Planification familiale/Technologie contraceptive
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Kinésithérapie
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="card c-card">
                            <div class="card-header" id="headingFour">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                    <i class="fal fa-magic iconColor"></i>UE 4: Soins obstétricaux et néonataux d’urgence (SIO244)
                                </a>
                            </div>
                            <div id="collapseFour" class="collapse" aria-labelledby="headingFour" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Biologie de la reproduction humaine
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Consultation prénatale recentrée
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Accouchement à risque Soins obstétricaux et néonataux d’urgence de base (SONUB) Soins obstétricaux et néonataux d’urgence complets (SONUC)
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Santé périnatale et néonatale (SPNN)
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="datas=='SAGES-FEMMES'" class="about-faq-area about-faq-area-page pb-100 c-padding-top c-semestre2">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-12">
                <div class="about-faq-content">
                    <!-- <span class="critereTitle">Le contenu de la formation</span> -->
                    <!-- <h2 class="title titleMaster">SCIENCES INFIRMIÈRES</h2> -->
                    <h2 class="title titleMaster c-premier">TROISIÈME ANNÉE</h2>
                    <h2 class="title titleMaster c-semestre">Cinquième semestre :</h2>
                </div>
                <div class="faq-accordion-3">
                    <div class="accordion" id="accordionExample">
                        <div class="card c-card">
                            <div class="card-header" id="headingOne">
                                <a class="" href="" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                    <i class="fal fa-magic iconColor"></i>UE 1: Connaissances de base liées aux fonctions infirmières et sage-femmes (SIO351)
                                </a>
                            </div>
                            <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Droit administratif
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Droit administratif
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="card c-card">
                            <div class="card-header" id="headingTwo">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                    <i class="fal fa-magic iconColor"></i>UE 2: Situation clinique se référant à la physiologie et aux pathologies du corps humain (SIO352)
                                </a>
                            </div>
                            <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Imagerie médicale
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Pédiatrie (Immunisation, PCIME)
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="card c-card">
                            <div class="card-header" id="headingThree">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                    <i class="fal fa-magic iconColor"></i>UE 3: Santé communautaire (SIO353)
                                </a>
                            </div>
                            <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Gestion des catastrophes/Fléaux sociaux
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Démographie
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Psycho-sociologie/Anthropologie
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="card c-card">
                            <div class="card-header" id="headingFour">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                    <i class="fal fa-magic iconColor"></i>UE 4: Prise en charge des affections courantes (SIO354)
                                </a>
                            </div>
                            <div id="collapseFour" class="collapse" aria-labelledby="headingFour" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Pharmacologie
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Psychiatrie
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Santé sexuelle/ santé de la reproduction des adolescents et des jeunes
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Drogue et tabagisme
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Affections de l’appareil reproducteur
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Approche genre
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Gérontologie/andropause/ménopause
                                    </p>
                                </div>

                            </div>
                        </div>
                        <div class="card c-card">
                            <div class="card-header" id="headingFive">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                                    <i class="fal fa-magic iconColor"></i>UE 5: Soins obstétricaux et néonataux d’urgence (SIO355)
                                </a>
                            </div>
                            <div id="collapseFive" class="collapse" aria-labelledby="headingFive" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Soins obstétricaux et néonataux d’urgence de base (SONUB)
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Soins obstétricaux et néonataux d’urgence 10 complets (SONUC)
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Santé périnatale et néonatale (SPNN)
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Activités cliniques
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div *ngIf="datas=='SAGES-FEMMES'" class="about-faq-area about-faq-area-page pb-100 c-padding-top c-semestre2">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-12">
                <div class="about-faq-content">
                    <!-- <span class="critereTitle">Le contenu de la formation</span> -->
                    <!-- <h2 class="title titleMaster">SCIENCES INFIRMIÈRES</h2> -->
                    <h2 class="title titleMaster c-premier">TROISIÈME ANNÉE</h2>
                    <h2 class="title titleMaster c-semestre">Sixième semestre :</h2>
                </div>
                <div class="faq-accordion-3">
                    <div class="accordion" id="accordionExample">
                        <div class="card c-card">
                            <div class="card-header" id="headingOne">
                                <a class="" href="" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                    <i class="fal fa-magic iconColor"></i>UE 1: Connaissances de base liées aux fonctions infirmières et sage-femmes (SIO361)
                                </a>
                            </div>
                            <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Déontologie et éthique professionnelle
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="card c-card">
                            <div class="card-header" id="headingTwo">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                    <i class="fal fa-magic iconColor"></i>UE 2: Processus de la recherche (SIO362)
                                </a>
                            </div>
                            <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Méthodes statistiques
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Initiation à la recherche
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="card c-card">
                            <div class="card-header" id="headingThree">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                    <i class="fal fa-magic iconColor"></i>UE 3: Management des Soins Infirmiers et Obstétricaux (SIO363)
                                </a>
                            </div>
                            <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Rédaction administrative
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Formation/Supervision
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Gestion/Administration
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Documents normatifs en santé
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="card c-card">
                            <div class="card-header" id="headingFour">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                    <i class="fal fa-magic iconColor"></i>UE 4: Soins obstétricaux et néonataux d’urgence (tâches déléguées) (SIO364)
                                </a>
                            </div>
                            <div id="collapseFour" class="collapse" aria-labelledby="headingFour" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Ventouse
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Aspiration Manuelle Intra-Utérine (AMIU)
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Dépistage des cancers du col de l’utérus (IVL/IVA)
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Sage femme -->


<!--start infirmier d'etat -->
<div class="blog-standard-area" *ngIf="datas=='INFIRMIER'">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-12">
                <div class="blog-standard">
                    <div class="single-blog-standard  mt-30">
                        <div class="blog-dteails-content blog-border">
                            <div class="blog-details-top">
                                <span>Les objectifs</span>
                            </div>
                            <br>
                            <div class="blog-details-bath">
                                <p class="c-description">L'approche par compétences sert de cadre de référence pour former des infirmiers (ou infirmières) et des sage-femmes (ou maïeuticiens) aptes à assurer les démarches en promotion et en prévention, à réaliser des soins conformes
                                    aux attentes de la population et des professionnels de la santé.</p>
                            </div>

                            <br>

                            <div class="blog-details-top">
                                <span><div class="blog-details-top">
                                    <span>Compétences communes</span>
                            </div>
                            </span>
                        </div>
                        <br>
                        <div class="blog-details-bath">
                            <ul class="list-group c-paddingLeft">
                                <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>C1. Analyser la fonction liée aux professions infirmières et sage-femmes ;</a></li>
                                <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>C2. Prendre en charge une situation clinique en se référant à la physiologie et aux pathologies du corps humain ;</a></li>
                                <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>C3. Intervenir en santé communautaire ;</a></li>
                                <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>C4. Appliquer les méthodes et techniques des soins infirmiers et obstétricaux ;</a></li>
                                <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>C5. Appliquer le processus de la recherche ;</a></li>
                                <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>C6. Assurer le management des soins infirmiers et obstétricaux ;</a></li>
                                <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>C7. Assurer les soins promotionnels, préventifs et ré-adaptatifs du couple
                                    « Mère-enfant ».
                                    </a></li>
                            </ul>
                        </div>
                        <div class="blog-details-top">
                            <span><div class="blog-details-top">
                                <span>Compétences spécifiques</span>
                        </div>
                        </span>
                    </div>
                    <br>
                    <div class="blog-details-bath">
                        <h6 class="c-option">Option : infirmier</h6>
                        <ul class="list-group c-paddingLeft">
                            <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>C8. Prodiguer des soins infirmiers ;</a></li>
                            <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>C9. Assurer la prise en charge des pathologies médico-chirurgicales ;</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</div>
</div>


<div class="blog-standard-area" *ngIf="datas=='INFIRMIER'">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-12">
                <div class="blog-standard">
                    <div class="single-blog-standard  mt-30">
                        <div class="blog-dteails-content blog-border">
                            <div class="blog-details-top">
                                <span>DUREE DES ETUDES </span>
                            </div>
                            <br>
                            <div class="blog-details-bath">
                                <p class="c-description">La durée de la formation est de six (06) semestres à raison de deux (02) semestres par an. Un Semestre dure 14 à 16 semaines d'enseignement théorique, d'enseignement pratique, d'enseignement clinique et d'évaluations.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="blog-standard-area" *ngIf="datas=='INFIRMIER'">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-12">
                <div class="blog-standard">
                    <div class="single-blog-standard  mt-30">
                        <div class="blog-dteails-content blog-border">
                            <div class="blog-details-top">
                                <span>Les conditions d’admission</span>
                            </div>
                            <br>
                            <div class="blog-details-bath">
                                <!-- <p class="c-description">La formation peut être suivie en formation initiale, en formation continue ou en alternance (contrat de professionnalisation). <br> Admission par un jury après examen des dossiers de candidature et entretien de motivation.
                                    <br> Peuvent être admis, les candidats ayant des bases sérieuses en informatique et/ou informatique industrielle, issus de formations telles que :
                                </p> -->
                                <ul class="list-group c-paddingLeft">
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Concours direct : Baccalauréat toutes séries ;</a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Pour les non ressortissants de l'espace CEDEAO : Baccalauréat toutes séries et études de dossiers ;</a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Pour les agents de santé : concours professionnel</a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Être apte sur le plan physique, mental et moral.</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>





<div *ngIf="datas=='INFIRMIER'" class="about-faq-area about-faq-area-page pb-100 c-padding-top">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-12">
                <div class="about-faq-content">
                    <span class="critereTitle">Le contenu de la formation</span>
                    <h2 class="title titleMaster">SCIENCES INFIRMIÈRES</h2>
                    <h2 class="title titleMaster c-premier">PREMIÈRE ANNÉE (TRONC COMMUN) </h2>
                    <h2 class="title titleMaster c-semestre">Premier semestre :</h2>
                </div>
                <div class="faq-accordion-3">
                    <div class="accordion" id="accordionExample">
                        <div class="card c-card">
                            <div class="card-header" id="headingOne">
                                <a class="" href="" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                    <i class="fal fa-magic iconColor"></i>UE 1: Connaissances de base liées aux fonctions infirmières et sage-femmes (SIO111)
                                </a>
                            </div>
                            <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Déontologie et éthique professionnelle
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Système National de Santé
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Législation du travail
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Profession infirmière/sage-femme
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="card c-card">
                            <div class="card-header" id="headingTwo">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                    <i class="fal fa-magic iconColor"></i>UE 2: Connaissance de base du corps et de l’alimentation (SIO112)
                                </a>
                            </div>
                            <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Anatomie-Physiologie générale et Anatomie-Physiologie obstétricale
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Puériculture
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Nutrition
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Diététique
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="card c-card">
                            <div class="card-header" id="headingThree">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                    <i class="fal fa-magic iconColor"></i>UE 3: Notions de bases sur les situations cliniques se référant aux pathologies (SIO113)
                                </a>
                            </div>
                            <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Microbiologie
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Hématologie
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;IST/VIH Sida
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Pathologies chirurgicales/sémiologie
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Pathologies médicales/sémiologie
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="card c-card">
                            <div class="card-header" id="headingFour">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                    <i class="fal fa-magic iconColor"></i>UE 4: Santé communautaire (SIO114)
                                </a>
                            </div>
                            <div id="collapseFour" class="collapse" aria-labelledby="headingFour" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Généralité sur la santé communautaire
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Approches de santé communautaire
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Etude du milieu
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Psycho-sociologie/anthropologie
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="card c-card">
                            <div class="card-header" id="headingFive">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                                    <i class="fal fa-magic iconColor"></i>UE 5: Simulation des méthodes et techniques de base en Soins Infirmiers et obstétricaux (SIO115)
                                </a>
                            </div>
                            <div id="collapseFive" class="collapse" aria-labelledby="headingFive" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Théorie et concepts des SI/obstétricaux
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Relation d’aide
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Techniques de soins de base en médecine et en chirurgie
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Secourisme
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="card c-card">
                            <div class="card-header" id="headingSix">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                                    <i class="fal fa-magic iconColor"></i>UE 6: Outils de recherche (SIO116)
                                </a>
                            </div>
                            <div id="collapseSix" class="collapse" aria-labelledby="headingSix" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Anglais professionnel
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Statistiques
                                    </p>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="btnn">
                            <a class="main-btn btnBorder" routerLink='/'>PRE-INSCRIPTION</a>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div *ngIf="datas=='INFIRMIER'" class="about-faq-area about-faq-area-page pb-100 c-padding-top c-semestre2">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-12">
                <div class="about-faq-content">
                    <!-- <span class="critereTitle">Le contenu de la formation</span> -->
                    <!-- <h2 class="title titleMaster">SCIENCES INFIRMIÈRES</h2> -->
                    <h2 class="title titleMaster c-premier">PREMIÈRE ANNÉE (TRONC COMMUN)</h2>
                    <h2 class="title titleMaster c-semestre">Deuxième semestre :</h2>
                </div>
                <div class="faq-accordion-3">
                    <div class="accordion" id="accordionExample">
                        <div class="card c-card">
                            <div class="card-header" id="headingOne">
                                <a class="" href="" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                    <i class="fal fa-magic iconColor"></i>UE 1: Prise en charge des affections primaires I (SIO121)
                                </a>
                            </div>
                            <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Anatomie-Physiologie générale et obstétricale
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Maladies parasitaires
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Biochimie
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Techniques de laboratoire
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Maladies Infectieuses
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="card c-card">
                            <div class="card-header" id="headingTwo">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                    <i class="fal fa-magic iconColor"></i>UE 2: Prise en charge des affections primaires II (SIO122)
                                </a>
                            </div>
                            <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Parasitologie
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Pédiatrie
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Pathologies respiratoires
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Maladies non transmissibles
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Pharmacologie spéciale
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="card c-card">
                            <div class="card-header" id="headingThree">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                    <i class="fal fa-magic iconColor"></i>UE 3: Santé communautaire (SIO123)
                                </a>
                            </div>
                            <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Hygiène et assainissement
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Soins de Santé Primaires
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Épidémiologie
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;IEC/CCC
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="card c-card">
                            <div class="card-header" id="headingFour">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                    <i class="fal fa-magic iconColor"></i>UE 4: Méthodes et Techniques des Soins Infirmiers et obstétricaux (SIO124)
                                </a>
                            </div>
                            <div id="collapseFour" class="collapse" aria-labelledby="headingFour" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Démarche de soins
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Techniques de soins de base
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Soins Infirmiers obstétricaux/néonataux de base/infantiles
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="card c-card">
                            <div class="card-header" id="headingFive">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                                    <i class="fal fa-magic iconColor"></i>UE 5: Processus de la recherche en santé (SIO125)
                                </a>
                            </div>
                            <div id="collapseFive" class="collapse" aria-labelledby="headingFive" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;TIC (Bureautique et Internet)
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>



<div *ngIf="datas=='INFIRMIER'" class="about-faq-area about-faq-area-page pb-100 c-padding-top c-semestre2">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-12">
                <div class="about-faq-content">
                    <!-- <span class="critereTitle">Le contenu de la formation</span>
                    <h2 class="title titleMaster">SCIENCES INFIRMIÈRES</h2> -->
                    <h2 class="title titleMaster c-premier">DEUXIÈME ANNÉE</h2>
                    <h2 class="title titleMaster c-semestre">Troisième semestre :</h2>
                </div>
                <div class="faq-accordion-3">
                    <div class="accordion" id="accordionExample">
                        <div class="card c-card">
                            <div class="card-header" id="headingOne">
                                <a class="" href="" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                    <i class="fal fa-magic iconColor"></i>UE 1: Situation clinique se référant à la physiologie et aux pathologies du corps humain (SIO231)
                                </a>
                            </div>
                            <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Pathologies obstétricales I
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Pathologies gynécologiques I
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="card c-card">
                            <div class="card-header" id="headingTwo">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                    <i class="fal fa-magic iconColor"></i>UE 2: Santé communautaire (SIO232)
                                </a>
                            </div>
                            <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Stratégies conventionnelles et novatrices de communication (IEC/CCC, CIP, Plaidoyer)
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="card c-card">
                            <div class="card-header" id="headingThree">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                    <i class="fal fa-magic iconColor"></i>UE 3: Méthodes et techniques des soins Infirmiers et obstétricaux (SIO233)
                                </a>
                            </div>
                            <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Soins infirmiers obstétricaux/néonataux
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="card c-card">
                            <div class="card-header" id="headingFour">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                    <i class="fal fa-magic iconColor"></i>UE 4: Soins promotionnels, préventifs et ré adaptatifs (SIO234)
                                </a>
                            </div>
                            <div id="collapseFour" class="collapse" aria-labelledby="headingFour" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Suivi post natal
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Consultation des enfants sains
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Planification familiale/Technologie contraceptive
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Kinésithérapie
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="card c-card">
                            <div class="card-header" id="headingFive">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                                    <i class="fal fa-magic iconColor"></i>UE 5: Soins infirmiers (SIO235)
                                </a>
                            </div>
                            <div id="collapseFive" class="collapse" aria-labelledby="headingFive" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Prise en charge infirmière
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="card c-card">
                            <div class="card-header" id="headingSix">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                                    <i class="fal fa-magic iconColor"></i>UE 6: Prise en charge des pathologies médicochirurgicales (SIO236)
                                </a>
                            </div>
                            <div id="collapseSix" class="collapse" aria-labelledby="headingSix" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Prise en charge infirmière
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Traumatologie
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Chirurgies digestives
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div *ngIf="datas=='INFIRMIER'" class="about-faq-area about-faq-area-page pb-100 c-padding-top c-semestre2">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-12">
                <div class="about-faq-content">
                    <!-- <span class="critereTitle">Le contenu de la formation</span>
                    <h2 class="title titleMaster">SCIENCES INFIRMIÈRES</h2> -->
                    <h2 class="title titleMaster c-premier">DEUXIÈME ANNÉE</h2>
                    <h2 class="title titleMaster c-semestre">Quatrième semestre :</h2>
                </div>
                <div class="faq-accordion-3">
                    <div class="accordion" id="accordionExample">
                        <div class="card c-card">
                            <div class="card-header" id="headingOne">
                                <a class="" href="" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                    <i class="fal fa-magic iconColor"></i>UE 1: Situation clinique se référant à la physiologie et aux pathologies du corps humain (SIO241)
                                </a>
                            </div>
                            <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Pathologies obstétricales I
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Pathologies gynécologiques I
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="card c-card">
                            <div class="card-header" id="headingTwo">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                    <i class="fal fa-magic iconColor"></i>UE 2: Méthodes et Techniques des Soins Infirmiers et obstétricaux (SIO242)
                                </a>
                            </div>
                            <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Soins infirmiers à la mère et au nouveau-né
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="card c-card">
                            <div class="card-header" id="headingThree">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                    <i class="fal fa-magic iconColor"></i>UE 3: Processus de la recherche (SIO243)
                                </a>
                            </div>
                            <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Initiation à la recherche en sciences infirmières
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="card c-card">
                            <div class="card-header" id="headingFour">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                    <i class="fal fa-magic iconColor"></i>UE 4: Prise en charge des affections courantes (SIO244)
                                </a>
                            </div>
                            <div id="collapseFour" class="collapse" aria-labelledby="headingFour" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Pharmacologie
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Psychiatrie
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Santé sexuelle/ santé de la reproduction des adolescents et des jeunes
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Drogue et tabagisme
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Affections de l’appareil reproducteur
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Approche genre
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Gérontologie/andropause/ménopause
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="card c-card">
                            <div class="card-header" id="headingFive">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                                    <i class="fal fa-magic iconColor"></i>UE 5: Soins infirmiers (SIO245)
                                </a>
                            </div>
                            <div id="collapseFive" class="collapse" aria-labelledby="headingFive" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Soins infirmiers spécialisés
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="card c-card">
                            <div class="card-header" id="headingSix">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                                    <i class="fal fa-magic iconColor"></i>UE 6: Prise en charge des pathologies médicochirurgicales (SIO246)
                                </a>
                            </div>
                            <div id="collapseSix" class="collapse" aria-labelledby="headingSix" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Affections respiratoires II
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Pathologies digestives
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Traumatologie
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Réanimation
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Chirurgie digestive et parties molles
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Urologie
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div *ngIf="datas=='INFIRMIER'" class="about-faq-area about-faq-area-page pb-100 c-padding-top c-semestre2">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-12">
                <div class="about-faq-content">
                    <!-- <span class="critereTitle">Le contenu de la formation</span>
                    <h2 class="title titleMaster">SCIENCES INFIRMIÈRES</h2> -->
                    <h2 class="title titleMaster c-premier">TROISIÈME ANNÉE</h2>
                    <h2 class="title titleMaster c-semestre">Cinquième semestre :</h2>
                </div>
                <div class="faq-accordion-3">
                    <div class="accordion" id="accordionExample">
                        <div class="card c-card">
                            <div class="card-header" id="headingOne">
                                <a class="" href="" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                    <i class="fal fa-magic iconColor"></i>UE 1: Situation clinique se référant à la physiologie et aux pathologies du corps humain (SIO351)
                                </a>
                            </div>
                            <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Imagerie médicale
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Pédiatrie
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="card c-card">
                            <div class="card-header" id="headingTwo">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                    <i class="fal fa-magic iconColor"></i>UE 2: Santé communautaire (SIO352)
                                </a>
                            </div>
                            <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Démographie
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="card c-card">
                            <div class="card-header" id="headingThree">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                    <i class="fal fa-magic iconColor"></i>UE 3: Soins infirmiers (SIO353)
                                </a>
                            </div>
                            <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Soins infirmiers spécialisés
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="card c-card">
                            <div class="card-header" id="headingFour">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                    <i class="fal fa-magic iconColor"></i>UE 4: Prise en charge spécialisée des pathologies médico-chirurgicales I (SIO354)
                                </a>
                            </div>
                            <div id="collapseFour" class="collapse" aria-labelledby="headingFour" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Stomatologie
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Oncologie
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Neurologie
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Endocrinologie
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Cardiologie
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="card c-card">
                            <div class="card-header" id="headingFive">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                                    <i class="fal fa-magic iconColor"></i>UE 5: Prise en charge spécialisée des pathologies médico-chirurgicales II (SIO355)
                                </a>
                            </div>
                            <div id="collapseFive" class="collapse" aria-labelledby="headingFive" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Psychiatrie
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Néphrologie/urologie
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Dermatologie
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Neurochirurgie
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;ORL
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Ophtalmologie
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div *ngIf="datas=='INFIRMIER'" class="about-faq-area about-faq-area-page pb-100 c-padding-top c-semestre2">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-12">
                <div class="about-faq-content">
                    <!-- <span class="critereTitle">Le contenu de la formation</span>
                    <h2 class="title titleMaster">SCIENCES INFIRMIÈRES</h2> -->
                    <h2 class="title titleMaster c-premier">TROISIÈME ANNÉE</h2>
                    <h2 class="title titleMaster c-semestre">Sixième semestre :</h2>
                </div>
                <div class="faq-accordion-3">
                    <div class="accordion" id="accordionExample">
                        <div class="card c-card">
                            <div class="card-header" id="headingOne">
                                <a class="" href="" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                    <i class="fal fa-magic iconColor"></i>UE 1: Santé communautaire (SIO361)
                                </a>
                            </div>
                            <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Gestion des catastrophes/Fléaux sociaux
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Démographie
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Participation communautaire
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="card c-card">
                            <div class="card-header" id="headingTwo">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                    <i class="fal fa-magic iconColor"></i>UE 2: Processus de la recherche (SIO362)
                                </a>
                            </div>
                            <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Initiation à la recherche en sciences infirmières
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="card c-card">
                            <div class="card-header" id="headingThree">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                    <i class="fal fa-magic iconColor"></i>UE 3: Management des Soins Infirmiers et Obstétricaux (SIO363)
                                </a>
                            </div>
                            <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Rédaction administrative
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Formation/Supervision
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Gestion/Administration
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Documents normatifs en santé
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--end infirmier d'état -->


<!--start Licence en Informatique et Réseaux Industriels -->

<div class="blog-standard-area" *ngIf="datas=='InformatiqueReseauxIndustriel'">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-12">
                <div class="blog-standard">
                    <div class="single-blog-standard  mt-30">
                        <div class="blog-dteails-content blog-border">
                            <div class="blog-details-top">
                                <span>Les objectifs</span>
                            </div>
                            <br>
                            <div class="blog-details-bath">
                                <p class="c-description">Cette formation vise à former des cadres possédant les savoirs fondamentaux, les compétences technologiques et les outils/méthodes nécessaires à la définition, à la mise en oeuvre et au développement de procédés dans les
                                    domaines de la micro-informatique et l’informatique industrielle. L’accent est mis sur: </p>
                                <ul class="list-group c-paddingLeft">
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>L’approfondissement des savoirs fondamentaux et des connaissances technologiques liés à la formation technique dans le domaine de l’informatique professionnelle</a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>L’apprentissage et le développement de l’autonomie et du travail en équipe</a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>La maîtrise des outils et méthodes nécessaires pour faire face aux évolutions rapides des activités informatiques</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="blog-standard-area" *ngIf="datas=='InformatiqueReseauxIndustriel'">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-12">
                <div class="blog-standard">
                    <div class="single-blog-standard  mt-30">
                        <div class="blog-dteails-content blog-border">
                            <div class="blog-details-top">
                                <span>Métiers visés</span>
                            </div>
                            <br>
                            <div class="blog-details-bath">
                                <ul class="list-group c-paddingLeft">
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Gestionnaire de parc micro-informatique</a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Responsable de support technique</a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Développeur en informatique industrielle</a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Assistant ingénieur en réseaux industriels</a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Cadre technique d’études / recherche / développement de l’industrie</a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Tous les secteurs contenant de l’informatique sont visés</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="blog-standard-area" *ngIf="datas=='InformatiqueReseauxIndustriel'">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-12">
                <div class="blog-standard">
                    <div class="single-blog-standard  mt-30">
                        <div class="blog-dteails-content blog-border">
                            <div class="blog-details-top">
                                <span>Les conditions d’admission</span>
                            </div>
                            <br>
                            <div class="blog-details-bath">
                                <p class="c-description">La formation peut être suivie en formation initiale, en formation continue ou en alternance (contrat de professionnalisation). <br> Admission par un jury après examen des dossiers de candidature et entretien de motivation.
                                    <br> Peuvent être admis, les candidats ayant des bases sérieuses en informatique et/ou informatique industrielle, issus de formations telles que :
                                </p>
                                <ul class="list-group c-paddingLeft">
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>L2 Mathématiques et informatique, Sciences de la matière, Sciences pour l’ingénieur</a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>DUT Génie électrique et informatique industrielle, Réseaux et télécommunications, Informatique, Mesures physiques, Génie mécanique et productique</a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>BTS Systèmes numériques, Services informatiques aux organisations</a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Techniciens supérieurs AFPA de maintenance et service informatique</a></li>

                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="datas=='InformatiqueReseauxIndustriel'" class="about-faq-area about-faq-area-page pb-100 c-padding-top">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-12">
                <div class="about-faq-content">
                    <span class="critereTitle">Le contenu de la formation</span>
                    <h2 class="title titleMaster">Licence en Informatique et Réseaux Industriels</h2>
                </div>
                <div class="faq-accordion-3 mt-30">
                    <div class="accordion" id="accordionExample">
                        <div class="card c-card">
                            <div class="card-header" id="headingOne">
                                <a class="" href="" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                    <i class="fal fa-magic iconColor"></i>UE 1 – conception de logiciels
                                </a>
                            </div>
                            <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Maîtriser les bases de la programmation structurée et l’approche modulaire.
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Analyser les besoins et mettre en œuvre une méthodologie de description et de conception du logiciel.
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Concevoir une application en langage orienté objet.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="card c-card">
                            <div class="card-header" id="headingTwo">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                    <i class="fal fa-magic iconColor"></i>UE 2 – architecture des ordinateurs, programmation industrielle
                                </a>
                            </div>
                            <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
                                <div class="card-body">
                                    <!-- <h1 class="titreAc">Les épreuves d’entrée au master sont écrites. Il s’agit de :</h1> -->
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Connaître l’architecture et le fonctionnement interne d’un ordinateur;
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Concevoir et programmer des systèmes automatisés
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Concevoir, programmer et tester des systèmes
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Mettre en œuvre des applications temps réel
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="card c-card">
                            <div class="card-header" id="headingThree">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                    <i class="fal fa-magic iconColor"></i>UE 3 – administration système – supervision de réseaux industriels
                                </a>
                            </div>
                            <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Mettre en place et administrer une solution de groupe de travail avec application à l’administration
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Installer et paramétrer le matériel et les logiciels pour un réseau local
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Mettre en œuvre des automates et réseaux d’automates développer sous la technologie «Dot Net»
                                    </p>




                                </div>
                            </div>
                        </div>

                        <div class="card c-card">
                            <div class="card-header" id="headingFour">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                    <i class="fal fa-magic iconColor"></i>UE 4 – gestion de projet – communication
                                </a>
                            </div>
                            <div id="collapseFour" class="collapse" aria-labelledby="headingFour" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Connaître et maîtriser les principes de la gestion de projet
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Communiquer à l’écrit et à l’oral en entreprise et avec les clients
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="card c-card">
                            <div class="card-header" id="headingFive">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                                    <i class="fal fa-magic iconColor"></i>UE 5 – projet d’intégration (toutes disciplines)
                                </a>
                            </div>
                            <div id="collapseFive" class="collapse" aria-labelledby="headingFive" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Organiser son travail et se coordonner avec les autres
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Être capable de concevoir une solution de réseau
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Communiquer à l’oral et à l’écrit
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="card c-card">
                            <div class="card-header" id="headingSix">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                                    <i class="fal fa-magic iconColor"></i>UE 6 – accès au système d’information
                                </a>
                            </div>
                            <div id="collapseSix" class="collapse" aria-labelledby="headingSix" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Développer un site Web dynamique (Javascript/PhP/MySQL)
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Administrer une base de données relationnelle
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Sécuriser un réseau local (FireWall NetAsq)
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="card c-card">
                            <div class="card-header" id="headingSeven">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven">
                                    <i class="fal fa-magic iconColor"></i>UE 7 – anglais TD
                                </a>
                            </div>
                            <div id="collapseSeven" class="collapse" aria-labelledby="headingSeven" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Comprendre et s’exprimer en anglais scientifique et technique à l’écrit et à l’oral
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="card c-card">
                            <div class="card-header" id="headingheihgt">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseheihgt" aria-expanded="false" aria-controls="collapseheihgt">
                                    <i class="fal fa-magic iconColor"></i>UE 8 – projet technologique
                                </a>
                            </div>
                            <div id="collapseheihgt" class="collapse" aria-labelledby="headingheihgt" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Réaliser un projet en équipe
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Rechercher et synthétiser l’information
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Communiquer à l’oral et à l’écrit
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="card c-card">
                            <div class="card-header" id="headingNine">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseNine" aria-expanded="false" aria-controls="collapseNine">
                                    <i class="fal fa-magic iconColor"></i>UE 9 – stage
                                </a>
                            </div>
                            <div id="collapseNine" class="collapse" aria-labelledby="headingNine" data-parent="#accordionExample">
                                <div class="card-body">
                                    <!-- <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;UE 9 – stage
                                    </p> -->
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;S’intégrer et communiquer au sein de l’entreprise et avec les clients
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Mettre en application les compétences acquises lors des enseignements et des projets
                                    </p>
                                </div>
                            </div>
                        </div>

                        <!-- <div class="btnn">
                            <a class="main-btn btnBorder" routerLink='/'>PRE-INSCRIPTION</a>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!--end Licence en Informatique et Réseaux Industriels -->


<!--start Genie Biologique -->
<div class="blog-standard-area" *ngIf="datas=='GENIE-BIOLOGIQUE'">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-12">
                <div class="blog-standard">
                    <div class="single-blog-standard  mt-30">
                        <div class="blog-dteails-content blog-border">
                            <div class="blog-details-top">
                                <span>Les objectifs</span>
                            </div>
                            <br>
                            <div class="blog-details-bath">
                                <p class="c-description">La Licence prépare à la fois à l'intégration dans la vie professionnelle et à la poursuite d'études. La licence Biologie vise avant tout à l'acquisition d’une autonomie dans la démarche expérimentale, particulièrement en
                                    sciences de la santé, des connaissances académiques fondamentales dans le domaine de la biologie et des compétences techniques avérées et recherchées dans les grands champs disciplinaires que sont l’hématologie-immunologie,
                                    la bactériologie-virologie, la parasitologie-mycologie, la biochimie, la biologie moléculaire , l’anatomie-pathologie... <br> En outre, le diplôme de licence de biologie appliquée permet au titulaire :
                                </p>
                                <ul class="list-group c-paddingLeft">
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>D’acquérir des compétences managériales</a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>De maîtriser  les moyens de communication modernes </a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>De faciliter sa mobilité  vers des formations complémentaires.</a></li>
                                </ul>
                                <p class="c-description">La finalité de la formation vise l’acquisition de connaissances, de compétences spécifiques, d’attitudes et de professionnalisme dans les différents domaines de la Biologie.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="blog-standard-area" *ngIf="datas=='GENIE-BIOLOGIQUE'">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-12">
                <div class="blog-standard">
                    <div class="single-blog-standard  mt-30">
                        <div class="blog-dteails-content blog-border">
                            <div class="blog-details-top">
                                <span>LES CONDITIONS D’ADMISSION</span>
                            </div>
                            <br>
                            <div class="blog-details-bath">
                                <p class="c-description">
                                    Peuvent s'inscrire en première année tout étudiant titulaire d'un baccalauréat séries S1 ou S2 ou d'un diplôme jugé équivalent par une commission pédagogique dans le cadre de la formation continue avec éventuellement des validations d'acquis professionnels
                                    (VAP ou VAE).
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="blog-standard-area" *ngIf="datas=='GENIE-BIOLOGIQUE'">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-12">
                <div class="blog-standard">
                    <div class="single-blog-standard  mt-30">
                        <div class="blog-dteails-content blog-border">
                            <div class="blog-details-top">
                                <span>Organisation générale des études</span>
                            </div>
                            <br>
                            <div class="blog-details-bath">
                                <p class="c-description">La licence de biologie offre aux étudiants une spécialisation progressive au long des six semestres. La première année est une année d’orientation (Outils de Base en Sciences fondamentales) et de formation pluridisciplinaire
                                    (Démarche Qualité, Biosécurité/Bio-sûreté, Anglais, Informatique…). Il s'établit une véritable progression au sein du parcours de formation : le premier et le second semestre permettent d'approfondir les bases scientifiques,
                                    d'évaluer les aptitudes et d'appréhender les motivations des étudiants. <br> Après un premier semestre les étudiants s’orientent encore plus vers la mention de biologie appliquée plus approfondie. <br> Au cours des
                                    semestres 3 et 4, un approfondissement des connaissances et une diversification des compétences sont introduits par des enseignements théoriques et pratiques y compris les stages en laboratoire et en milieu industriel
                                    en vue d’ enrichir le parcours de l'étudiant, en lui donnant des éléments à une diversification de ces compétences dans le domaine de la biologie appliquée. <br> A la fin du parcours de licence, la réalisation d’un
                                    rapport de stage par l’étudiant est obligatoire.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="blog-standard-area" *ngIf="datas=='GENIE-BIOLOGIQUE'">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-12">
                <div class="blog-standard">
                    <div class="single-blog-standard  mt-30">
                        <div class="blog-dteails-content blog-border">
                            <div class="blog-details-top">
                                <span>Poursuite d'études</span>
                            </div>
                            <br>
                            <div class="blog-details-bath">
                                <p class="c-description">La validation de la licence de biologie autorise une poursuite d’études dans les masters suivants :
                                </p>
                                <ul class="list-group c-paddingLeft">
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Biologie de la reproduction (recherche et professionnel)</a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Biologie moléculaire </a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Infectiologie cellulaire et moléculaire, vaccinologie (recherche et professionnel)</a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Biotechnologies (professionnel)</a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Goût et innovation en agroalimentaire (professionnel)</a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Physiologie, biomolécules et thérapeutiques (recherche)</a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Produits de santé : production, réglementation et qualité (professionnel). 2 parcours :</a></li>
                                </ul>
                                <ul class="list-group c-paa">
                                    <li><a class="c-Text"><i class="fas fa-circle mr-10 c-icon"></i>Qualité et gestion des risques en santé</a></li>
                                    <li><a class="c-Text"><i class="fa fa-circle mr-10 c-icon"></i>Pharmacotechnie, contrôle, affaires technico-réglementaires </a></li>
                                    <li><a class="c-Text"><i class="fa fa-circle mr-10 c-icon"></i>Nutition/alimentation/diététique etc.</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="blog-standard-area pb-60" *ngIf="datas=='GENIE-BIOLOGIQUE'">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-12">
                <div class="blog-standard">
                    <div class="single-blog-standard  mt-30">
                        <div class="blog-dteails-content blog-border">
                            <div class="blog-details-top">
                                <span>Débouchés professionnels</span>
                            </div>
                            <br>
                            <div class="blog-details-bath">
                                <p class="c-description">Après avoir effectué des stages et acquis des compétences professionnelles complémentaires, dans le cadre d'un master ou d'une école spécialisée, l'étudiant peut accéder à des secteurs d'activités tels que :
                                </p>
                                <ul class="list-group c-paddingLeft">
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Laboratoire de Biologie Médicale</a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Laboratoire de recherche </a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Laboratoire de toxicologie</a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Laboratoire de police scientifique</a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Laboratoire d’industrie agroalimentaire</a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Les biotechnologies</a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>L'environnement </a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Les Laboratoire de cosmétologie </a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>l'industrie pharmaceutique… </a></li>

                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- <div *ngIf="datas=='GENIE-BIOLOGIQUE'" class="about-faq-area about-faq-area-page pb-100 c-padding-top">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-12">
                <div class="about-faq-content">
                    <span class="critereTitle">Le contenu de la formation</span>
                    <h2 class="title titleMaster">Licence en Informatique et Réseaux Industriels</h2>
                </div>
                <div class="faq-accordion-3 mt-30">
                    <div class="accordion" id="accordionExample">
                        <div class="card c-card">
                            <div class="card-header" id="headingOne">
                                <a class="" href="" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                    <i class="fal fa-magic iconColor"></i>UE 1 – conception de logiciels
                                </a>
                            </div>
                            <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Maîtriser les bases de la programmation structurée et l’approche modulaire.
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Analyser les besoins et mettre en œuvre une méthodologie de description et de conception du logiciel.
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Concevoir une application en langage orienté objet.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="card c-card">
                            <div class="card-header" id="headingTwo">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                    <i class="fal fa-magic iconColor"></i>UE 2 – architecture des ordinateurs, programmation industrielle
                                </a>
                            </div>
                            <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Connaître l’architecture et le fonctionnement interne d’un ordinateur;
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Concevoir et programmer des systèmes automatisés
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Concevoir, programmer et tester des systèmes
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Mettre en œuvre des applications temps réel
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="card c-card">
                            <div class="card-header" id="headingThree">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                    <i class="fal fa-magic iconColor"></i>UE 3 – administration système – supervision de réseaux industriels
                                </a>
                            </div>
                            <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Mettre en place et administrer une solution de groupe de travail avec application à l’administration
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Installer et paramétrer le matériel et les logiciels pour un réseau local
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Mettre en œuvre des automates et réseaux d’automates développer sous la technologie «Dot Net»
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="card c-card">
                            <div class="card-header" id="headingFour">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                    <i class="fal fa-magic iconColor"></i>UE 4 – gestion de projet – communication
                                </a>
                            </div>
                            <div id="collapseFour" class="collapse" aria-labelledby="headingFour" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Connaître et maîtriser les principes de la gestion de projet
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Communiquer à l’écrit et à l’oral en entreprise et avec les clients
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="card c-card">
                            <div class="card-header" id="headingFive">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                                    <i class="fal fa-magic iconColor"></i>UE 5 – projet d’intégration (toutes disciplines)
                                </a>
                            </div>
                            <div id="collapseFive" class="collapse" aria-labelledby="headingFive" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Organiser son travail et se coordonner avec les autres
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Être capable de concevoir une solution de réseau
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Communiquer à l’oral et à l’écrit
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="card c-card">
                            <div class="card-header" id="headingSix">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                                    <i class="fal fa-magic iconColor"></i>UE 6 – accès au système d’information
                                </a>
                            </div>
                            <div id="collapseSix" class="collapse" aria-labelledby="headingSix" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Développer un site Web dynamique (Javascript/PhP/MySQL)
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Administrer une base de données relationnelle
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Sécuriser un réseau local (FireWall NetAsq)
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="card c-card">
                            <div class="card-header" id="headingSeven">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven">
                                    <i class="fal fa-magic iconColor"></i>UE 7 – anglais TD
                                </a>
                            </div>
                            <div id="collapseSeven" class="collapse" aria-labelledby="headingSeven" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Comprendre et s’exprimer en anglais scientifique et technique à l’écrit et à l’oral
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="card c-card">
                            <div class="card-header" id="headingheihgt">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseheihgt" aria-expanded="false" aria-controls="collapseheihgt">
                                    <i class="fal fa-magic iconColor"></i>UE 8 – projet technologique
                                </a>
                            </div>
                            <div id="collapseheihgt" class="collapse" aria-labelledby="headingheihgt" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Réaliser un projet en équipe
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Rechercher et synthétiser l’information
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Communiquer à l’oral et à l’écrit
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="card c-card">
                            <div class="card-header" id="headingNine">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseNine" aria-expanded="false" aria-controls="collapseNine">
                                    <i class="fal fa-magic iconColor"></i>UE 9 – stage
                                </a>
                            </div>
                            <div id="collapseNine" class="collapse" aria-labelledby="headingNine" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;S’intégrer et communiquer au sein de l’entreprise et avec les clients
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Mettre en application les compétences acquises lors des enseignements et des projets
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="btnn">
                            <a class="main-btn btnBorder" routerLink='/'>PRE-INSCRIPTION</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->

<!--end Genie Biologique -->


<!--start LICENCE EN STATISTIQUE ET INFORMATIQUE DÉCISIONNELLE -->
<div class="blog-standard-area" *ngIf="datas=='LICENCE-STATISTIQUE-INFORMATIQUE-DECISIONNELLE'">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-12">
                <div class="blog-standard">
                    <div class="single-blog-standard  mt-30">
                        <div class="blog-dteails-content blog-border">
                            <div class="blog-details-top">
                                <span>description</span>
                            </div>
                            <br>
                            <div class="blog-details-bath">
                                <p class="c-description">L’informatique Décisionnelle (Business Intelligence) et la statistique apportent une aide à la décision en transformant des données brutes en informations utiles. <br> Formez-vous aux nouveaux concepts et outils pour le
                                    Big Data Chaque jour, nous générons plusieurs trillions d’octets de données : messages sur les sites de médias sociaux, images numériques et vidéos publiées en ligne, enregistrements transactionnels d'achats en ligne,
                                    données climatiques issues de capteurs,... Ces données sont appelées Big Data ou volumes massifs de données. <br> Les grands défis à surmonter dans le « Big Data » sont les « 3V » :
                                </p>
                                <ul class="list-group c-paddingLeft">
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>La prise en compte de données très volumineuses (Volume)</a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Le traitement de données arrivant sous forme de flux continus en temps réel (Vélocité)</a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>L’hétérogénéité des provenances et des types des sources de données (Variété)</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="blog-standard-area" *ngIf="datas=='LICENCE-STATISTIQUE-INFORMATIQUE-DECISIONNELLE'">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-12">
                <div class="blog-standard">
                    <div class="single-blog-standard  mt-30">
                        <div class="blog-dteails-content blog-border">
                            <div class="blog-details-top">
                                <span>Objectifs de la formation</span>
                            </div>
                            <br>
                            <div class="blog-details-bath">
                                <p class="c-description">
                                    La Licence Professionnelle Métiers du Décisionnel et de la Statistique forme des spécialistes du décisionnel, avec plusieurs compétences:Informatique Décisionnelle ( Business Intelligence), Statistique et Big Data.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="blog-standard-area" *ngIf="datas=='LICENCE-STATISTIQUE-INFORMATIQUE-DECISIONNELLE'">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-12">
                <div class="blog-standard">
                    <div class="single-blog-standard  mt-30">
                        <div class="blog-dteails-content blog-border">
                            <div class="blog-details-top">
                                <span>Les conditions d’admission</span>
                            </div>
                            <br>
                            <div class="blog-details-bath">
                                <p class="c-description">
                                    Le recrutement se fait sur étude de dossiers et entretien :
                                </p>
                                <ul class="list-group c-paddingLeft">
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Des titulaires de diplôme Bac+2 ou de niveau III ayant suivi une formation à contenu scientifique suffisant: L2 Mathématiques, Informatique, BTS: IG, SIO, SRC, DUT: Informatique, GEII, SRC, STID, DEUST: BCEE...</a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Des diplômés de niveau III dans le domaine, dans le cadre de la Validation d'Acquis de l'Expérience (VAE).</a></li>
                                </ul>
                                <p class="c-description">
                                    Les salariés et demandeurs d'emploi non titulaires des titres cités ci-dessus peuvent avoir accès à la licence après Validation de leurs Acquis Professionnels (VAP). <br> La licence est ouverte aussi bien aux candidats
                                    en formation initiale qu'aux candidats en formation continue. La formation est notamment ouverte aux demandeurs d'emploi, aux salariés en plan de formation ou congé individuel de formation.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="blog-standard-area" *ngIf="datas=='LICENCE-STATISTIQUE-INFORMATIQUE-DECISIONNELLE'">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-12">
                <div class="blog-standard">
                    <div class="single-blog-standard  mt-30">
                        <div class="blog-dteails-content blog-border">
                            <div class="blog-details-top">
                                <span>Compétences acquises</span>
                            </div>
                            <br>
                            <div class="blog-details-bath">
                                <ul class="list-group c-paddingLeft">
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Conduire un projet décisionnel </a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Concevoir, réaliser et exploiter des bases de données, les entrepôts de données</a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Mettre en place des programmes d'alimentation des entrepôts de données grâce à des ETLs</a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Mettre en place des analyses multidimensionnelles (cubes OLAP, requêtes MDX)</a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Utiliser les méthodes et techniques de statistique et de datamining pour extraire de la connaissance à partir des données</a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Réaliser des études statistiques, des études marketing...</a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Concevoir et réaliser un tableau de bord</a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Mettre en place des solutions de visualisation (dashboard Web, reporting, data navigation)</a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Restituer les données à l'aide de soutils de reporting et de visualisation ( QlikView,BO)</a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Mettre en place des portails web décisionnels</a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Mettre en place une architecture d'analyse et traitement des données Big Data</a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Analyser des données massives-big data (Statistique, Machine Learning)</a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Assurer la veille technique dans son domaine de compétence...</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="blog-standard-area" *ngIf="datas=='LICENCE-STATISTIQUE-INFORMATIQUE-DECISIONNELLE'">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-12">
                <div class="blog-standard">
                    <div class="single-blog-standard  mt-30">
                        <div class="blog-dteails-content blog-border">
                            <div class="blog-details-top">
                                <span>Métiers actuels et futurs</span>
                            </div>
                            <br>
                            <div class="blog-details-bath">
                                <p class="c-description">
                                    Tous les secteurs d'activité: Grande distribution, Banque, Assurances, Industrie, E-Commerce, Santé,... <br> Les diplômés peuvent occuper les postes suivants:
                                </p>
                                <ul class="list-group c-paddingLeft">
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Concepteur-réalisateur décisionnel</a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Analyste décisionnel</a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Chargé d'études statistiques </a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Chargé d'études marketing </a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Chargé de reporting</a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Consultant décisionnel</a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Chef de projet décisionnel...</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="blog-standard-area" *ngIf="datas=='LICENCE-STATISTIQUE-INFORMATIQUE-DECISIONNELLE'">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-12">
                <div class="blog-standard">
                    <div class="single-blog-standard  mt-30">
                        <div class="blog-dteails-content blog-border">
                            <div class="blog-details-top">
                                <span>Nota bene (NB)</span>
                            </div>
                            <br>
                            <div class="blog-details-bath">
                                <p class="c-description">
                                    La formation est ouverte sur l'entreprise ; elle comporte :
                                </p>
                                <ul class="list-group c-paddingLeft">
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Alternance Entreprise / IUT (2,5 jours Entreprise et 2,5 IUT) ou un stage en entreprise (16 semaines)</a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Des séminaires sur les nouveautés technologiques du domaine et des témoignages de professionnels sur des applications décisionnelles concrètes.</a></li>
                                </ul>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div *ngIf="datas=='LICENCE-STATISTIQUE-INFORMATIQUE-DECISIONNELLE'" class="about-faq-area about-faq-area-page pb-100 c-padding-top">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-12">
                <div class="about-faq-content">
                    <span class="critereTitle">Le contenu de la formation</span>
                    <h2 class="title titleMaster">Licence en Statistique et Informatique Décisionnelle</h2>
                </div>
                <div class="faq-accordion-3 mt-30">
                    <div class="accordion" id="accordionExample">
                        <div class="card c-card">
                            <div class="card-header" id="headingOne">
                                <a class="" href="" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                    <i class="fal fa-magic iconColor"></i>UE 1: Modules différenciés de mise à niveau
                                </a>
                            </div>
                            <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Statistiques et Probabilités.
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Bases de données.
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Tableurs.
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Logiciels statistiques.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="card c-card">
                            <div class="card-header" id="headingTwo">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                    <i class="fal fa-magic iconColor"></i>UE 2: Statistique et Analyse des données
                                </a>
                            </div>
                            <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
                                <div class="card-body">
                                    <!-- <h1 class="titreAc">Les épreuves d’entrée au master sont écrites. Il s’agit de :</h1> -->
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Statistiques
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Logiciels Statistiques et de datamining (SAS)
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Datamining
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Analyse de données
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Statistiques avancées (Statistique inférentielle et modèles linéaires)
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Logiciels statistiques et de Data Mining (SPSS, Géomarketing)
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="card c-card">
                            <div class="card-header" id="headingThree">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                    <i class="fal fa-magic iconColor"></i>UE 3: Informatique et Informatique Décisionnelle
                                </a>
                            </div>
                            <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Système d’information et bases de données (ORACLE)
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Système d’information et logiciels décisionnels (Qlick View, BO, ETL)
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Développement Web
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Système d’information et logiciels décisionnels (OLAP, TBB)
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="card c-card">
                            <div class="card-header" id="headingFour">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                    <i class="fal fa-magic iconColor"></i>UE 4: Expression, Communication et Environnement de l’entreprise
                                </a>
                            </div>
                            <div id="collapseFour" class="collapse" aria-labelledby="headingFour" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Marketing
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Anglais
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Techniques de communication
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="card c-card">
                            <div class="card-header" id="headingFive">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                                    <i class="fal fa-magic iconColor"></i>UE 5: Big Data (Données massives)
                                </a>
                            </div>
                            <div id="collapseFive" class="collapse" aria-labelledby="headingFive" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Ecosystème Big Data et bases de données pour le big data
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Traitement Big data
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Apprentissage automatique (Machine Learning)
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Gestion de la relation client
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="card c-card">
                            <div class="card-header" id="headingSix">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                                    <i class="fal fa-magic iconColor"></i>UE 6: Projets Tuteurés
                                </a>
                            </div>
                            <!-- <div id="collapseSix" class="collapse" aria-labelledby="headingSix" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Développer un site Web dynamique (Javascript/PhP/MySQL)
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Administrer une base de données relationnelle
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Sécuriser un réseau local (FireWall NetAsq)
                                    </p>
                                </div>
                            </div> -->
                        </div>

                        <div class="card c-card">
                            <div class="card-header" id="headingSeven">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven">
                                    <i class="fal fa-magic iconColor"></i>UE 7: Stages
                                </a>
                            </div>
                            <div id="collapseSeven" class="collapse" aria-labelledby="headingSeven" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Activités optionnelles « Unité d’Enseignement libre »
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="card c-card">
                            <div class="card-header" id="headingheihgt">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseheihgt" aria-expanded="false" aria-controls="collapseheihgt">
                                    <i class="fal fa-magic iconColor"></i>UE 8: Engagement civique
                                </a>
                            </div>
                            <!-- <div id="collapseheihgt" class="collapse" aria-labelledby="headingheihgt" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Réaliser un projet en équipe
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Rechercher et synthétiser l’information
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Communiquer à l’oral et à l’écrit
                                    </p>
                                </div>
                            </div> -->
                        </div>

                        <div class="card c-card">
                            <div class="card-header" id="headingNine">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseNine" aria-expanded="false" aria-controls="collapseNine">
                                    <i class="fal fa-magic iconColor"></i>UE 9: Activités Physiques et/ou Sportives
                                </a>
                            </div>
                            <!-- <div id="collapseNine" class="collapse" aria-labelledby="headingNine" data-parent="#accordionExample">
                                <div class="card-body">

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;S’intégrer et communiquer au sein de l’entreprise et avec les clients
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Mettre en application les compétences acquises lors des enseignements et des projets
                                    </p>
                                </div>
                            </div> -->
                        </div>

                        <div class="card c-card">
                            <div class="card-header" id="headingTen">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseTen" aria-expanded="false" aria-controls="collapseTen">
                                    <i class="fal fa-magic iconColor"></i>UE 10: Activités culturelles
                                </a>
                            </div>
                            <!-- <div id="collapseTen" class="collapse" aria-labelledby="headingTen" data-parent="#accordionExample">
                                <div class="card-body">

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;S’intégrer et communiquer au sein de l’entreprise et avec les clients
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Mettre en application les compétences acquises lors des enseignements et des projets
                                    </p>
                                </div>
                            </div> -->
                        </div>


                        <!-- <div class="btnn">
                            <a class="main-btn btnBorder" routerLink='/'>PRE-INSCRIPTION</a>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!--end LICENCE EN STATISTIQUE ET INFORMATIQUE DÉCISIONNELLE -->


<!--start Gestion et administration des biens -->


<div class="blog-standard-area" *ngIf="datas=='GestionAdministrationBien'">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-12">
                <div class="blog-standard">
                    <div class="single-blog-standard  mt-30">
                        <div class="blog-dteails-content blog-border">
                            <div class="blog-details-top">
                                <span>Desciption</span>
                            </div>
                            <br>
                            <div class="blog-details-bath">
                                <p class="c-description">La Licence Professionnelle Métiers de l’Immobilier : Gestion et Administration de Biens forme des professionnels qui s’intégreront au secteur de l’immobilier. </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="blog-standard-area" *ngIf="datas=='GestionAdministrationBien'">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-12">
                <div class="blog-standard">
                    <div class="single-blog-standard  mt-30">
                        <div class="blog-dteails-content blog-border">
                            <div class="blog-details-top">
                                <span>Les objectifs</span>
                            </div>
                            <br>
                            <div class="blog-details-bath">
                                <p class="c-description">La Licence Professionnelle Métiers de l’Immobilier : Gestion et Administration de Biens vise à former des diplômés capables de : </p>
                                <ul class="list-group c-paddingLeft">
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Gérer un site immobilier</a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Utiliser la démarche marketing pour promouvoir une entreprise du secteur immobilier</a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Mettre en œuvre les moyens techniques et administratifs de gestion immobilière</a></li>
                                </ul>
                                <p class="c-description">Deux parcours sont proposés :</p>
                                <ul class="list-group c-paa">
                                    <li><a class="c-Text"><i class="fas fa-circle mr-10 c-icon"></i>Un Parcours “Gestion du patrimoine” : débouche sur des métiers en relation avec la gérance de copropriété ou de syndic d’immeuble</a></li>
                                    <li><a class="c-Text"><i class="fa fa-circle mr-10 c-icon"></i>Un Parcours “Habitat Social” : permet de gérer un parc immobilier locatif dans le domaine de l’habitat social, de maîtriser les procédures de passation des marchés publics, de gérer les divers recouvrements</a></li>
                                </ul>
                                <p class="c-description">L’insertion professionnelle est facilitée par :</p>
                                <ul class="list-group c-paa">
                                    <li><a class="c-Text"><i class="fas fa-circle mr-10 c-icon"></i>L’organisation des cours en alternance</a></li>
                                    <li><a class="c-Text"><i class="fa fa-circle mr-10 c-icon"></i>Le contrat de professionnalisation</a></li>
                                    <li><a class="c-Text"><i class="fa fa-circle mr-10 c-icon"></i>Le partenariat noué avec l’ICH-ICEU (Institutd’études économiques et juridiques appliquées à la Construction et à l’Habitat, Institut de la Construction, de l’Environnement et de l’Urbanisme)</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="blog-standard-area" *ngIf="datas=='GestionAdministrationBien'">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-12">
                <div class="blog-standard">
                    <div class="single-blog-standard  mt-30">
                        <div class="blog-dteails-content blog-border">
                            <div class="blog-details-top">
                                <span>Public visé</span>
                            </div>
                            <br>
                            <div class="blog-details-bath">
                                <p class="c-description">
                                    La formation s’adresse aux titulaires :
                                </p>
                                <ul class="list-group c-paddingLeft">
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>D’une L2 ayant une formation compatible avec la licence professionnelle et qui souhaitent s’insérer dans le monde professionnel</a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>D’un DUT, d’un BTS, d’un DEUST.</a></li>
                                </ul>
                                <p class="c-description">
                                    La licence est ouverte aux salariés en plan de formation ou Congé Individuel de Formation, ainsi qu’aux demandeurs d’emploi. <br> Le recrutement se fait sur dossier de candidature et entretien.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="blog-standard-area" *ngIf="datas=='GestionAdministrationBien'">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-12">
                <div class="blog-standard">
                    <div class="single-blog-standard  mt-30">
                        <div class="blog-dteails-content blog-border">
                            <div class="blog-details-top">
                                <span>Compétences acquises</span>
                            </div>
                            <br>
                            <div class="blog-details-bath">
                                <p class="c-description">
                                    Parcours “Gestion du patrimoine” :
                                </p>
                                <ul class="list-group c-paddingLeft">
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Prospecter et évaluer des biens immobiliers</a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Administrer une copropriété</a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Rédiger les actes nécessaires à l’acquisition d’un bien, à sa location ou à sa gérance</a></li>
                                </ul>
                                <p class="c-description">
                                    Parcours “Habitat social” :
                                </p>
                                <ul class="list-group c-paddingLeft">
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Maîtriser les procédures de passation des marchés publics</a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Gérer les divers recouvrements</a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Maîtriser la pratique opérationnelle des baux</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="blog-standard-area" *ngIf="datas=='GestionAdministrationBien'">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-12">
                <div class="blog-standard">
                    <div class="single-blog-standard  mt-30">
                        <div class="blog-dteails-content blog-border">
                            <div class="blog-details-top">
                                <span>Métiers actuels et futurs</span>
                            </div>
                            <br>
                            <div class="blog-details-bath">
                                <ul class="list-group c-paddingLeft">
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Négociateur immobilier</a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Conseiller commercial</a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Chargé de clientèle en location</a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Consultant en immobilier</a></li>
                                    <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Gestionnaire de copropriété junior…</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>



<div *ngIf="datas=='GestionAdministrationBien'" class="about-faq-area about-faq-area-page pb-100 c-padding-top">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-12">
                <div class="about-faq-content">
                    <span class="critereTitle">Le contenu de la formation</span>
                    <h2 class="title titleMaster">Licence Gestion et Administration des Biens</h2>
                </div>
                <div class="faq-accordion-3 mt-30">
                    <div class="accordion" id="accordionExample">
                        <div class="card c-card">
                            <div class="card-header" id="headingOne">
                                <a class="" href="" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                    <i class="fal fa-magic iconColor"></i>UE 1 : Environnement juridique et économique
                                </a>
                            </div>
                            <!-- <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Maîtriser les bases de la programmation structurée et l’approche modulaire.
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Analyser les besoins et mettre en œuvre une méthodologie de description et de conception du logiciel.
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Concevoir une application en langage orienté objet.
                                    </p>
                                </div>
                            </div> -->
                        </div>
                        <div class="card c-card">
                            <div class="card-header" id="headingTwo">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                    <i class="fal fa-magic iconColor"></i>UE 2 : Outils fondamentaux
                                </a>
                            </div>
                            <!-- <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Connaître l’architecture et le fonctionnement interne d’un ordinateur;
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Concevoir et programmer des systèmes automatisés
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Concevoir, programmer et tester des systèmes
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Mettre en œuvre des applications temps réel
                                    </p>
                                </div>
                            </div> -->
                        </div>
                        <div class="card c-card">
                            <div class="card-header" id="headingThree">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                    <i class="fal fa-magic iconColor"></i>UE 3 : Outils transversaux
                                </a>
                            </div>
                            <!-- <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Mettre en place et administrer une solution de groupe de travail avec application à l’administration
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Installer et paramétrer le matériel et les logiciels pour un réseau local
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Mettre en œuvre des automates et réseaux d’automates développer sous la technologie «Dot Net»
                                    </p>
                                </div>
                            </div> -->
                        </div>
                        <div class="card c-card">
                            <div class="card-header" id="headingFour">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                    <i class="fal fa-magic iconColor"></i>UE 4 : Outils juridiques de l’immobilier
                                </a>
                            </div>
                            <!-- <div id="collapseFour" class="collapse" aria-labelledby="headingFour" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Connaître et maîtriser les principes de la gestion de projet
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Communiquer à l’écrit et à l’oral en entreprise et avec les clients
                                    </p>
                                </div>
                            </div> -->
                        </div>

                        <div class="card c-card">
                            <div class="card-header" id="headingFive">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                                    <i class="fal fa-magic iconColor"></i>UE 5 : Pratique de gestion
                                </a>
                            </div>
                            <!-- <div id="collapseFive" class="collapse" aria-labelledby="headingFive" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Organiser son travail et se coordonner avec les autres
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Être capable de concevoir une solution de réseau
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Communiquer à l’oral et à l’écrit
                                    </p>
                                </div>
                            </div> -->
                        </div>
                        <div class="card c-card">
                            <div class="card-header" id="headingSix">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                                    <i class="fal fa-magic iconColor"></i>UE 6 : Parcours Gestion du patrimoine / Parcours Habitat social
                                </a>
                            </div>
                            <!-- <div id="collapseSix" class="collapse" aria-labelledby="headingSix" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Développer un site Web dynamique (Javascript/PhP/MySQL)
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Administrer une base de données relationnelle
                                    </p>

                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Sécuriser un réseau local (FireWall NetAsq)
                                    </p>
                                </div>
                            </div> -->
                        </div>

                        <div class="card c-card">
                            <div class="card-header" id="headingSeven">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven">
                                    <i class="fal fa-magic iconColor"></i>UE 7 : Projets Tutorés
                                </a>
                            </div>
                            <!-- <div id="collapseSeven" class="collapse" aria-labelledby="headingSeven" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Comprendre et s’exprimer en anglais scientifique et technique à l’écrit et à l’oral
                                    </p>
                                </div>
                            </div> -->
                        </div>

                        <div class="card c-card">
                            <div class="card-header" id="headingheihgt">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseheihgt" aria-expanded="false" aria-controls="collapseheihgt">
                                    <i class="fal fa-magic iconColor"></i>UE 8 : Stage ou activité en entreprise
                                </a>
                            </div>
                            <!-- <div id="collapseheihgt" class="collapse" aria-labelledby="headingheihgt" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Réaliser un projet en équipe
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Rechercher et synthétiser l’information
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Communiquer à l’oral et à l’écrit
                                    </p>
                                </div>
                            </div> -->
                        </div>

                        <div class="card c-card">
                            <div class="card-header" id="headingNine">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseNine" aria-expanded="false" aria-controls="collapseNine">
                                    <i class="fal fa-magic iconColor"></i>UE 9 : Engagement Civique
                                </a>
                            </div>
                            <!-- <div id="collapseNine" class="collapse" aria-labelledby="headingNine" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;S’intégrer et communiquer au sein de l’entreprise et avec les clients
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Mettre en application les compétences acquises lors des enseignements et des projets
                                    </p>
                                </div>
                            </div> -->
                        </div>

                        <div class="card c-card">
                            <div class="card-header" id="headingTen">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseTen" aria-expanded="false" aria-controls="collapseTen">
                                    <i class="fal fa-magic iconColor"></i>UE 10 : Activités Physiques et sportives
                                </a>
                            </div>
                            <!-- <div id="collapseTen" class="collapse" aria-labelledby="headingTen" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;S’intégrer et communiquer au sein de l’entreprise et avec les clients
                                    </p>
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;Mettre en application les compétences acquises lors des enseignements et des projets
                                    </p>
                                </div>
                            </div> -->
                        </div>

                        <div class="card c-card">
                            <div class="card-header" id="headingEle">
                                <a class="collapsed" href="" data-toggle="collapse" data-target="#collapseEle" aria-expanded="false" aria-controls="collapseEle">
                                    <i class="fal fa-magic iconColor"></i>UE 11 : Activités culturelles
                                </a>
                            </div>
                            <!-- <div id="collapseEle" class="collapse" aria-labelledby="headingEle" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="para">
                                        <i class="fal fa-check iconColor"></i>&nbsp;&nbsp;S’intégrer et communiquer au sein de l’entreprise et avec les clients
                                    </p>
                                    <p class="para">
                                        <i class="fal
                                        a-check iconColor"></i>&nbsp;&nbsp;Mettre en application les compétences acquises lors des enseignements et des projets
                                    </p>
                                </div>
                            </div> -->
                        </div>

                        <!-- <div class="btnn">
                            <a class="main-btn btnBorder" routerLink='/'>PRE-INSCRIPTION</a>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- end Gestion et administrattion des biens -->
















<app-footer2></app-footer2>
